import { RefreshButton } from './RefreshButton'
import { AddButton } from './AddButton'
import { FilterButton } from './FilterButton'
import { MongoSortButton } from './SortButton/MongoSortButton'
import { MongoSearchInput } from './SearchInput/MongoSearchInput'
import type React from 'react'

export type Components = {
  refresh?: React.ElementType
  add?: React.ElementType
  filter?: React.ElementType
  sort?: React.ElementType
  search?: React.ElementType
  other?: any
}

export const components: Components = {
  refresh: RefreshButton,
  add: AddButton,
  filter: FilterButton,
  sort: MongoSortButton,
  search: MongoSearchInput,
  other: () => null,
}
